import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */
export const history: ThemeUICSSObject = {
  /* PREPEND HERE */

  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: 2,
  p: 3,

  '.history_message': {
    px: 4,
    py: 5,
    maxWidth: 'calc(100% - 50px)',
    width: 'fit-content',
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    borderRadius: 'chatMessage',

    '&.last': {
      mb: 4,
    },

    '&.user': {
      '&.first': {
        borderTopRightRadius: '0px',
      },

      backgroundColor: 'rgb(108 166 203)', // TODO: Set the correct color, if necessary, define it in palette
      color: 'white', // TODO: Set the correct color, if necessary, define it in palette
      boxShadow: 'rgba(50, 50, 93, 0.15) 1px 1px 2px 1px', // TODO: Set the correct color, if necessary, define it in palette
      border: '1px solid rgb(113 145 193)', // TODO: Set the correct color, if necessary, define it in palette
      alignSelf: 'end',
      display: 'flex',
      flexDirection: 'column',
    },

    '&.system': {
      '&.first': {
        borderTopLeftRadius: '0px',
      },

      backgroundColor: '#00bcff14', // TODO: Set the correct color, if necessary, define it in palette
      boxShadow: 'rgba(50, 50, 93, 0.15) 1px 1px 2px 1px', // TODO: Set the correct color, if necessary, define it in palette
      border: '1px solid rgb(0 28 38 / 18%)', // TODO: Set the correct color, if necessary, define it in palette
    },

    '&.warning': {
      borderRadius: '2px 20px 20px 20px',
      alignSelf: 'start',
      backgroundColor: '#ffff0024', // TODO: Set the correct color, if necessary, define it in palette
      width: '100%',
      boxShadow: 'rgba(50, 50, 93, 0.15) 1px 1px 2px 1px', // TODO: Set the correct color, if necessary, define it in palette
      border: '1px solid rgb(0 28 38 / 18%)', // TODO: Set the correct color, if necessary, define it in palette
    },

    '&.error': {
      borderRadius: '2px 20px 20px 20px',
      alignSelf: 'start',
      backgroundColor: '#fd84212b', // TODO: Set the correct color, if necessary, define it in palette
      width: '100%',
      boxShadow: 'rgba(50, 50, 93, 0.15) 1px 1px 2px 1px', // TODO: Set the correct color, if necessary, define it in palette
      border: '1px solid rgb(0 28 38 / 18%)', // TODO: Set the correct color, if necessary, define it in palette
    },

    '&.information': {
      borderRadius: '2px 20px 20px 20px',
      alignSelf: 'start',
      backgroundColor: '#00bcff14', //'#2222cc2b',
      width: '100%',
      boxShadow: 'rgba(50, 50, 93, 0.15) 1px 1px 2px 1px', // TODO: Set the correct color, if necessary, define it in palette
      border: '1px solid rgb(0 28 38 / 18%)', // TODO: Set the correct color, if necessary, define it in palette
    },
  },

  '.history_message__attachments': {
    display: 'flex',
    justifyContent: 'flex-end',

    '.labelBox': {
      width: 'max-content',
      background: '#fafafa',
      color: 'palette.text.primary',
      fontSize: '14px',
      '.labelAndIcon ': {
        fontSize: '14px',
      },
    },
  },
};
